export const deviceConfig = {
    IPhone: ['iPhone', 'iPad'],
    Android: ['Android'],
};

export const scrollTopOffset = {
    desktop: 72,
    mobile: 48,
};
